import {SettingParam} from "@/types/node";
import {Input} from "@/components/ui/input";
import {useEffect, useState} from "react";
import {useValidation} from "@/utils/validation";

export const SettingInput = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
  error,
  onBlur,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: string) => void;
  selectedNodeId: string;
  disabled: boolean;
  error?: string;
  onBlur?: (e: React.InputHTMLAttributes<HTMLInputElement>) => void;
}) => {
  const [value, setValue] = useState(param.value?.toString() || "");
  const maxLength = param.maxLength;
  const paramValue = param.value?.toString() || "";

  useEffect(() => {
    if (paramValue !== value) {
      setValue(paramValue);
    }
  }, [selectedNodeId]);

  const {error: validationError, validate} = useValidation(
    param.validationSchema as any,
  );

  return (
    <div className="mb-4 w-full">
      {param.label && (
        <label className="text-sm font-medium text-label mb-2 flex items-center justify-between">
          {param.label}
          {maxLength && (
            <span className="text-sm text-secondary">
              {value.length}/{maxLength}
            </span>
          )}
        </label>
      )}
      <Input
        className={`focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:bg-muted`}
        onChange={e => {
          setValue(e.target.value);
          validate(e.target.value);
          handleChange(param, e.target.value);
        }}
        value={value}
        placeholder={param.placeholder}
        disabled={disabled}
        maxLength={param.maxLength}
        error={error || validationError}
        onBlur={e => {
          onBlur?.(e);
        }}
      />
    </div>
  );
};
